import PropTypes from 'prop-types'
import React, { useContext, useEffect } from 'react'
import InputMask from 'react-input-mask'

import Context from '../../context'
import { ClearStringNumber } from '../../helpers/ClearStringNumber'
import { mapBox, viaCep } from '../../services/address'

function AddressForm({ title }) {
  const { formObject, setFormObject } = useContext(Context)
  const { latLong, setLatLong } = useContext(Context)

  useEffect(() => {
    const getZipCode = async () => {
      if (formObject.zipcode && formObject.zipcode.length > 6) {
        return viaCep(formObject.zipcode)
      }
      return null
    }

    if (formObject.zipcode && formObject.zipcode.length > 4) {
      getZipCode().then(address => {
        if (address) {
          setFormObject({
            ...formObject,
            zipcode: address.cep || formObject.zipcode,
            neighborhood: address.bairro || formObject.neighborhood,
            city: address.localidade || formObject.city,
            address: address.logradouro || formObject.address,
            uf: address.uf || formObject.uf
          })
        }
      })
    }
  }, [formObject.zipcode])

  useEffect(() => {
    const getLatLong = async () => {
      return mapBox(formObject)
    }
    getLatLong().then(latLongData => {
      if (latLongData) {
        setLatLong({
          lat: String(latLongData.lat),
          long: String(latLongData.long)
        })
      }
    })
  }, [formObject])

  return (
    <>
      <h5>{title}</h5>
      <div className="row">
        <div className="form-group col-md-3">
          <InputMask
            mask="99999-999"
            value={formObject.zipcode || ''}
            onChange={e => {
              setFormObject({
                ...formObject,
                zipcode: ClearStringNumber(e.target.value)
              })
            }}
            type="text"
            className="form-control"
            id="zipcode"
            placeholder="CEP"
          />
        </div>
        <div className="form-group col-md-6">
          <input
            value={formObject.address || ''}
            onChange={e => setFormObject({ ...formObject, address: e.target.value })}
            type="text"
            className="form-control"
            id="address"
            placeholder="Endereço"
          />
        </div>
        <div className="form-group col-md-3">
          <input
            value={formObject.number || ''}
            onChange={e => setFormObject({ ...formObject, number: e.target.value })}
            type="number"
            className="form-control"
            placeholder="Número"
          />
        </div>
        <div className="form-group col-md-4">
          <input
            value={formObject.neighborhood || ''}
            onChange={e => setFormObject({ ...formObject, neighborhood: e.target.value })}
            type="text"
            className="form-control"
            id="neighborhood"
            placeholder="Bairro"
          />
        </div>
        <div className="form-group col-md-3">
          <input
            value={formObject.complement || ''}
            onChange={e => setFormObject({ ...formObject, complement: e.target.value })}
            type="text"
            className="form-control"
            id="complement"
            placeholder="Complemento"
          />
        </div>
        <div className="form-group col-md-3">
          <input
            value={formObject.city || ''}
            onChange={e => setFormObject({ ...formObject, city: e.target.value })}
            type="text"
            className="form-control"
            id="city"
            placeholder="Cidade"
          />
        </div>
        <div className="form-group col-md-2">
          <input
            value={formObject.uf || ''}
            onChange={e => setFormObject({ ...formObject, uf: e.target.value })}
            type="text"
            className="form-control"
            id="state"
            placeholder="UF"
          />
        </div>
        <div className="form-group col-md-3">
          <input
            value={latLong.lat || ''}
            onChange={e => setLatLong({ ...latLong, lat: e.target.value })}
            type="text"
            className="form-control"
            id="lat"
            placeholder="Latitude"
          />
        </div>
        <div className="form-group col-md-3">
          <input
            value={latLong.long || ''}
            onChange={e => setLatLong({ ...latLong, long: e.target.value })}
            type="text"
            className="form-control"
            id="long"
            placeholder="Longitude"
          />
        </div>
        <div className="form-group col-md-6">
          <InputMask
            mask="(99) 9 9999-9999"
            value={formObject.localPhone || ''}
            id="localPhone"
            name="localPhone"
            onChange={e =>
              setFormObject({
                ...formObject,
                localPhone: ClearStringNumber(e.target.value)
              })
            }
            type="text"
            className="form-control"
            placeholder="Telefone do Estabelecimento"
          />
        </div>
      </div>
    </>
  )
}

AddressForm.defaultProps = {
  title: 'Endereço do Estabelecimento'
}

AddressForm.propTypes = {
  title: PropTypes.string
}

export default AddressForm
